// get styles
// import "./css/frontend-tailwind.css"
import "@/css/styles.css";

// get scripts
import "/js/scripts.js";
import '/js/footer.js';


/*
* Add recipe to favorites, we're using cookies to store the favorite recipes.
*/
let addRecipeToFavrorites = document.getElementById('add-to-favorite');
if (addRecipeToFavrorites) {
    addRecipeToFavrorites.addEventListener('click', function () {
        var recipeId = this.getAttribute('data-recipe');
        var favoriteRecipes = getCookie('favorite_recipes');

        if (favoriteRecipes) {
            favoriteRecipes = JSON.parse(favoriteRecipes);
        } else {
            favoriteRecipes = [];
        }

        var recipeIndex = favoriteRecipes.indexOf(recipeId);

        if (recipeIndex !== -1) {
            favoriteRecipes.splice(recipeIndex, 1);
        } else {
            favoriteRecipes.push(recipeId);
        }

        setCookie('favorite_recipes', JSON.stringify(favoriteRecipes), 365); /* We're saving the recipes for 1 year TODO: Check how long we should save the recipes */

        if (recipeIndex !== -1) {
            this.classList.remove('favorite');
        } else {
            this.classList.add('favorite');
        }
    });

    /*
    * On page load, check if the recipe is already in favorites.
    */
    document.addEventListener('DOMContentLoaded', function () {
        var favoriteRecipes = getCookie('favorite_recipes');
        if (favoriteRecipes) {
            favoriteRecipes = JSON.parse(favoriteRecipes);
        } else {
            favoriteRecipes = [];
        }

        var recipeId = document.getElementById('add-to-favorite').getAttribute('data-recipe');
        var recipeIndex = favoriteRecipes.indexOf(recipeId);

        if (recipeIndex !== -1) {
            document.getElementById('add-to-favorite').classList.add('favorite');
        }
    });
}

/*
* Share article
*/
let sharArticle = document.getElementById('share-article');
if (sharArticle) {
    let isHovering = false;
    sharArticle.addEventListener('mouseover', function () {
        var sharePopup = document.getElementById('share-popup');
        sharePopup.classList.remove('hidden');
        setTimeout(function () {
            sharePopup.classList.add('active');
        }, 10);
        isHovering = true;
    });

    sharArticle.addEventListener('mouseleave', function () {
        isHovering = false;
        setTimeout(function () {
            if (!isHovering) {
                document.getElementById('share-popup').classList.remove('active');
                setTimeout(function () {
                    document.getElementById('share-popup').classList.add('hidden');
                }, 300);
            }
        }, 1000);
    });
}

/* 
* Collapse functionality 
*/
let collapseOpen = document.querySelectorAll('.collapse-open');
if (collapseOpen) {
    collapseOpen.forEach(function (element) {
        element.addEventListener('click', function () {
            element.parentNode.classList.toggle('active');
        });
    });
}

/*
* Filter modal handling
*/
let filterSortBtn = document.getElementById('filter-sort-btn');
if (filterSortBtn) {
    filterSortBtn.addEventListener('click', function () {
        document.querySelector("body").classList.toggle('overflow-hidden');
        document.getElementById('filter-modal').classList.toggle('active');
        setTimeout(function () {
            document.getElementById('filter-modal').querySelector('.modal').classList.toggle('active');
        }, 10);
    });
}

let closeFilterModal = document.querySelectorAll('.close-filter-modal');
if (closeFilterModal) {
    closeFilterModal.forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector("body").classList.remove('overflow-hidden');
            document.getElementById('filter-modal').querySelector('.modal').classList.remove('active');
            setTimeout(function () {
                document.getElementById('filter-modal').classList.remove('active');
            }, 300);
        });
    });
}

document.addEventListener('click', function (event) {
    if(document.getElementById('filter-modal')) {
        if (!document.getElementById('filter-modal').contains(event.target) && !filterSortBtn.contains(event.target)) {
            document.querySelector("body").classList.remove('overflow-hidden');
            document.getElementById('filter-modal').querySelector('.modal').classList.remove('active');
            setTimeout(function () {
                document.getElementById('filter-modal').classList.remove('active');
            }, 300);
        }
    }
});

/*
* Filter
*/
let selectedFilters = [];
const filterModal = document.getElementById('filter-modal');
if (filterModal) {
    let filterItems = filterModal.querySelectorAll('.filter-item');
    let postType = filterModal.getAttribute('data-posttype');
    let taxonomies = filterModal.getAttribute('data-taxonomies');
    filterItems.forEach(item => {
        item.addEventListener('click', () => {
            let taxonomy = item.getAttribute('data-taxonomy');
            let termId = item.getAttribute('data-term');
            
            var existingTaxonomyIndex = selectedFilters.findIndex(
                filter => filter.taxonomy === taxonomy
            );
        
            var existingTermIdIndex = selectedFilters.findIndex(
                filter => filter.termId === termId
            );

            if (existingTermIdIndex !== -1) {
                selectedFilters.splice(existingTermIdIndex, 1);

                document.querySelectorAll(".filter-item[data-term='" + termId + "']").forEach(function(btn) {
                    btn.classList.remove("active");
                });
            } else {
                selectedFilters.push({ taxonomy: taxonomy, termId: termId });
                
                document.querySelectorAll(".filter-item[data-term='" + termId + "']").forEach(function(btn) {
                    btn.classList.add("active");
                });
            }

            // Load the filter results with the updated selected filters
            loadFilter(selectedFilters, postType, '', taxonomies);
        });
    });
}

/*
* Reset filters
*/
let resetFilters = document.querySelectorAll('.reset-filters');
if (resetFilters) {
    resetFilters.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            selectedFilters = [];
            let postType = item.getAttribute('data-posttype');

            document.querySelectorAll('.filter-item').forEach(function(btn) {
                btn.classList.remove("active");
            });

            // After reset, call loadFilter again
            loadFilter(selectedFilters, postType, true);
        });
    });
}

/*
* Load filters
*/
let isFiltering = false;
function loadFilter(selectedFilters, postType, isReset, taxonomies) {
    isFiltering = true;

    if (selectedFilters.length === 0) {
        isReset = true;
    }

    if (isReset && document.getElementById('load-more-posts')) {
        document.getElementById('load-more-posts').classList.remove('hidden');    
        document.getElementById('load-more-posts').setAttribute('data-total-loaded', 0);
        document.getElementById('load-more-posts').setAttribute('data-page', 2);
        isFiltering = false;
    } else if (isReset && postType === 'product') {
        let categoryWrappers = document.querySelectorAll('.category-wrapper');
        categoryWrappers.forEach(function (element) {
            element.classList.remove('hidden');
        });
        document.getElementById('filter-body').innerHTML = '';
        isFiltering = false;
        document.querySelector('.filter-heading').classList.remove('filtering');
    } else if (postType === 'product') {
        let categoryWrappers = document.querySelectorAll('.category-wrapper');
        categoryWrappers.forEach(function (element) {
            element.classList.add('hidden');
        });
        document.querySelector('.filter-heading').classList.add('filtering');
    }

    $.ajax({
        url: wpMildVariables.ajax_url,
        type: 'POST',
        data: {
            action: 'filter_posts',
            filters: selectedFilters,
            postType: postType,
            isReset: isReset,
            taxonomies: taxonomies
        },
        success: function (response) {

            if (isReset && postType === 'product') {
                document.getElementById('filter-body').innerHTML = '';
            } else {
                document.getElementById('filter-body').innerHTML = response.filter;
            }

            if (isFiltering && document.getElementById('load-more-posts')) {
                document.getElementById('load-more-posts').classList.add('hidden');
            }

            document.getElementById('amount-found').innerHTML = response.totalPosts;

            document.getElementById('filter-amount').innerHTML = response.totalPosts;

            updateFilterButtonState(response.unassigned_terms);
        }
    }); 
}

/*
* Update button states
*/
function updateFilterButtonState(unassigned_terms) {
    $('.filter-item').removeClass('disabled');

    $.each(unassigned_terms, function(taxonomy, termIds) {
        if (termIds && termIds.length > 0) {
            $.each(termIds, function(index, termId) {
                $('.filter-item[data-term="' + termId + '"]').addClass('disabled');
            });
        } else {
            $('.filter-item[data-taxonomy="' + taxonomy + '"]').removeClass('disabled');
        }
    });

    if (Object.keys(unassigned_terms).length === 0 || $.isEmptyObject(unassigned_terms)) {
        $('.filter-item').removeClass('disabled');
    }
}

/*
* Load more posts
*/
let loadMorePosts = document.querySelectorAll('#load-more-posts, .load-more-posts');
if (loadMorePosts) {
    loadMorePosts.forEach(function (element) {
        element.addEventListener('click', function () {
            element.setAttribute('disabled', 'disabled');
            loadPosts(element);
        });
    });
}

function loadPosts(button) {
    let postType = button.getAttribute('data-posttype');
    let page = button.getAttribute('data-page');
    let totalLoaded = button.getAttribute('data-total-loaded');
    let category = button.getAttribute('data-category') || '';
    let postsPerPage = button.getAttribute('data-posts-per-page') || 10;

    $.ajax({
        url: wpMildVariables.ajax_url,
        type: 'POST',
        data: {
            action: 'load_more_posts',
            postType: postType,
            page: page,
            totalLoaded: totalLoaded,
            category: category,
            postsPerPage: postsPerPage
        },
        success: function (response) {
            if (page == 1) {
                if(category) {
                    document.getElementById('filter-body-' + category).innerHTML = response.html;
                    totalLoaded = response.visible;
                } else {
                    document.getElementById('filter-body').innerHTML = response.html;
                    totalLoaded = response.visible;
                }
            } else {
                if(category) {
                    document.getElementById('filter-body-' + category).innerHTML += response.html;
                    totalLoaded = parseInt(totalLoaded) + parseInt(response.visible);
                } else {
                    document.getElementById('filter-body').innerHTML += response.html;
                    totalLoaded = parseInt(totalLoaded) + parseInt(response.visible);
                }
            }

            button.removeAttribute('disabled');
            button.setAttribute('data-total-loaded', totalLoaded);
            button.setAttribute('data-page', parseInt(page) + 1);

            if (response.total === totalLoaded) {
                button.classList.add('hidden');
            } else {
                button.classList.remove('hidden');
            }
        }
    });
}

/*
* Complaints form file upload
*/

document.querySelectorAll('.file-upload').forEach(input => {
    input.addEventListener('change', function(event) {

        let file_input = input.parentNode.querySelector('input[type="hidden"]');

        if (input.parentNode.querySelector('.error')) {
            input.parentNode.querySelector('.error').remove();
        }

        const formData = new FormData();

        formData.append('file', event.target.files[0]);
        formData.append('action', 'upload_complaint_file');
        formData.append('nonce', wpMildVariables.nonce);

        fetch(wpMildVariables.ajax_url, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {

                file_input.value = data.file_url;

            } else {
                /* We clear the input field if the file upload failed */
                input.value = ''; 
                file_input.value = '';

                let error = document.createElement('div');
                error.classList.add('error');
                error.innerHTML = data.message;
                input.parentNode.appendChild(error);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });
});

/*
* Cookie functions
*/
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}